// src/pages/admin/AdminFaqPanel.jsx
import React from "react";
import AdminFaqPanelComponent from "../../Components/AdminFaqPanelComponent";

/**
 * Страница-обёртка для AdminFaqPanelComponent.
 * Важные классы:
 * - h-screen: занимает всю высоту окна
 * - flex flex-col: колонная верстка
 * - header фиксирован, main — scrollable area с flex-1 min-h-0 overflow-y-auto
 *
 * Если у тебя другой layout (например App уже использует flex), просто убедись, что
 * родитель имеет min-h-0 у flex-элемента.
 */

function AdminFaqPanel() {
  // Для теста прокрутки можно добавить много элементов.
  // В рабочем варианте заменишь на реальные данные из Firestore или пропсы.
  const demoList = new Array(15).fill(0).map((_, i) => ({
    id: `demo-${i}`,
    question: `Демо вопрос ${i + 1}`,
    // длинный ответ, чтобы явно было что скроллить
    answer: `Длинный ответ ${i + 1}. `.repeat(30),
  }));

  return (
    <div className="h-screen flex flex-col bg-gray-50">
      {/* header */}
      <header className="p-4 bg-white border-b border-gray-200">
        <h1 className="text-xl font-semibold text-gray-800">Admin — FAQ</h1>
      </header>

      {/* main: scrollable area */}
      <main className="flex-1 min-h-0 overflow-y-auto p-4">
        <div className="space-y-4">
          {/* Если нужно один элемент — оставь один объект */}
          {demoList.map((item) => (
            <AdminFaqPanelComponent
              key={item.id}
              item={item}
              onUpdate={() => {}}
              onDelete={() => {}}
              type="faq"
            />
          ))}
        </div>
      </main>
    </div>
  );
}

export default AdminFaqPanel;
